import React, { useEffect, useState, memo } from "react";
import { Button, Tag, DatePicker, Dropdown, Menu, Modal } from "antd";
import "./styles.css";
import calendarIcon from "../../../assets/icons/calendar-icon.svg";
import { MoreOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { AiOutlineArrowLeft } from "react-icons/ai";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  getNotes,
  postNotes,
  resetUpdateNotes,
  updateNotes,
} from "../../../redux/actions";
import NotesForm from "./components/notesForm";
import noData from "../../../assets/img/noNotes.svg";
import { LoadingOutlined } from "@ant-design/icons";

const AddNotes = ({ skillListing }) => {
  const [wordCount, setWordCount] = React.useState(0);
  const [notes, setNotes] = React.useState();
  const [openCalendar, setOpenCalendar] = React.useState(false);
  const [startDate, setStartDate] = React.useState();
  const [endDate, setEndDate] = React.useState();
  const [openModal, setOpenModal] = React.useState(false);
  const [selecteNote, setSelectedNote] = React.useState();
  const [viewMore, setViewMore] = React.useState(false);
  const [load, setLoad] = useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const updateSuccess = useSelector(
    (state) => state.getProfileDetailsReducer.success
  );
  const postSuccess = useSelector(
    (state) => state.getProfileDetailsReducer.success
  );
  const [openCalendarE, setOpenCalendarE] = useState(false);

  const [errors, setErrors] = React.useState({
    notes: false,
    date: false,
  });

  const notesData = useSelector(
    (state) => state.getProfileDetailsReducer.notes
  );
  const createNotes = useSelector(
    (state) => state.getProfileDetailsReducer.createNotes
  );

  const dispatch = useDispatch();
  const { RangePicker } = DatePicker;

  const rangePicker = React.useRef();
  const deleteLoading = useSelector(
    (state) => state.getProfileDetailsReducer.loadingNotes
  );

  

  useEffect(() => { 
    setDeleteModal(false)
  },[updateSuccess])
  useEffect(() => {
}, [openCalendarE]);

useEffect(() => {
  if(skillListing?.length > 0) {
    dispatch(
      getNotes({
        id: skillListing?.length > 0 && skillListing[0].SkillListingId,
      })
    );
  }
}, []);

  useEffect(() => {
    if (createNotes || createNotes === "updated") {
      dispatch(
        getNotes({
          id: skillListing?.length > 0 && skillListing[0].SkillListingId,
        })
      );
    }
  }, [createNotes]);
  // const LoadingPostNotes = useSelector((state) => state.postNotes.load);
  const handleOk = () => {
    dispatch(
      updateNotes({
        noteId: selecteNote?._id,
        Status: "deleted",
      })
    );
    setTimeout(() => {
      dispatch(resetUpdateNotes());
      // setDeleteModal(false)
    }, [500]);
  };
  useEffect(() => {
    if (postSuccess) {
      setTimeout(() => {
        setLoad(false);
      }, [2000]);
    }
  }, [postSuccess, createNotes]);
  const finishForm = () => {
    if (endDate && notes) {
      // setLoad(true)
      dispatch(
        postNotes({
          SkillListingId:
            skillListing?.length > 0 && skillListing[0].SkillListingId,
          StartTime: startDate,
          EndTime: endDate,
          Note: notes,
        })
      );
      setStartDate();
      setEndDate();
      setNotes("");
      setLoad(true);
      setWordCount(0)
     

    } else {
      if (!notes) {
        setErrors({ ...errors, notes: true });
      } else if (!endDate) {
        setErrors({ ...errors, date: true });
      }
    }
  
  };

  useEffect(() => {
    if (updateSuccess) {
      setDeleteModal(false);
    }
  }, [updateSuccess]);

  const editHandler = (e) => {
    if (e.key === "Edit") {
      setOpenModal(true);
    } else if (e.key === "Delete") {
      setDeleteModal(true);
    }
  };
  const HnadleCloseCalender = () => {};

  const menu = (
    <Menu className="joblisting-dropdown" onClick={editHandler}>
      <Menu.Item key="Edit">Edit</Menu.Item>

      <Menu.Item key="Delete">Delete</Menu.Item>
    </Menu>
  );

  return (
    <div className="notes-main-container">
      <Modal
        title={null}
        open={openModal}
        footer={null}
        centered
        width={600}
        onCancel={() => {
          setOpenCalendarE(false);
          setTimeout(() => {
            setOpenModal(false);
            setOpenCalendar(false);
          }, [500]);
        }}
        
      >
        <div>Edit Note</div>
        <NotesForm
          data={skillListing}
          openModal={openModal}
          selecteNote={selecteNote}
          setOpenModal={setOpenModal}
          onChageCal={(val) => setOpenCalendarE(val)}
          openCalendarV={openCalendarE}
          // setOpenCalendarV={setOpenCalendarV}
        />
      </Modal>
      <Modal
        title={null}
        open={deleteModal}
        centered
        width={400}
        onCancel={() => {
          setDeleteModal(false);
        }}
        footer={[
          <>
            <Button
              onClick={() => {
                setDeleteModal(false);
              }}
              className="modal-no-btn"
            >
              No
            </Button>
            <Button onClick={handleOk} className="modal-ok-btn">
              {deleteLoading ? <LoadingOutlined /> : "Yes"}
            </Button>
          </>,
        ]}
      >
        <p>Do you want to delete the note?</p>
      </Modal>
      {!viewMore && (
        <>
          <div
            style={{
              fontWeight: "600",
              fontSize: "18px",
              color: "#3e3e3e",
            }}
          >
            Add notes
          </div>
          <div className="notes-main">
            <textarea
              className={
                (wordCount > 250  || errors.notes) && "notes-textarea-error"
              }
              rows={6}
              onChange={(e) => {
                setWordCount(e.target.value.length);
                setNotes(e.target.value);
                setErrors({ ...errors, notes: false });
              }}
              value={notes}
              maxlength={250}
              placeholder="Write your notes here"
            />
            <div className="notes-textarea-counts">
              <span id="Ratings-current-word-count">{wordCount}</span>
              <span id="Ratings-maximum-word-count"> / 250</span>
            </div>

            {wordCount === 250 || errors.notes ? (
              <div style={{ marginTop: "3%", color: "#fc5c5c" }}>
                {errors.notes
                  ? "Please add notes"
                  : "Can’t add more characters"}
              </div>
            ) : null}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "38px",
              }}
            >
              <div>
                <Button
                  className={
                    !errors.date ? "reminder-btn" : "reminder-btn-ERROR"
                  }
                  onClick={() => {
                    setOpenCalendar(!openCalendar);
                  }}
                  icon={
                    <img
                      src={calendarIcon}
                      style={{ marginRight: "4%", marginTop: "-5px" }}
                    />
                  }
                >
                  {startDate ? moment(startDate).format("MMMM DD, YYYY") : 'Set reminder'}
                </Button>
                <DatePicker
                  ref={rangePicker}
                  open={openCalendar}
                  style={{ zIndex: "-1", position: "absolute" }}
                  placement={"bottomRight"}
                  onChange={(e) => {
                    setStartDate(moment(e._d).toISOString());
                    setEndDate(moment(e._d).toISOString());
                    setErrors({ ...errors, date: false });

                    setTimeout(() => {
                      setOpenCalendar(false)
                    }, [300])
                }}
                onClick={(e) => {
                  setStartDate(moment(e._d).toISOString())
                  setEndDate(moment(e._d).toISOString())
                  setErrors({ ...errors, date: false })

                  setTimeout(() => {
                    setOpenCalendar(false)
                  }, [2000])
              }}
                disabledDate={(current) => {
                  return moment().add(-1, 'days') >= current
              }}
                />
              </div>
              <div className="notes-button-row">
                <button
                  id="btn1"
                  aria-details={wordCount===0 && `disabled`}
                  onClick={() => {
                    setNotes("");
                    setWordCount(0)
                  }}
                  disabled={wordCount == 0 ? true : false }
                >
                  Cancel
                </button>
                <button id="btn2" onClick={finishForm}>
                  {load ? <LoadingOutlined /> : "Save"}
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      <div
        style={{
          margin: "3% 0%",
          color: "#3e3e3e",
          fontWeight: "bold",
          fontSize: "18px",
        }}
      >
        {viewMore && (
          <AiOutlineArrowLeft
            className="notes-back-arrow"
            onClick={() => setViewMore(false)}
          />
        )}
        Recent notes reminders
      </div>
      {notesData.length > 0 ? (
        notesData.map((res, index) => {
          if (index <= 2 && !viewMore)
            return (
              <>
                <div className="notes-remonders-main" key={index}>
                  {/* {notesData.length == 0 &&
                        <div className='no-notes-main'>
                            <div>
                                image here
                            </div>
                            <div className='no-notes-text'>No Notes to show</div>
                            <div className='no-notest-text2'>
                                Create note to display here to the other team members. You can set reminder to avoid missing any deadlines
                            </div>
                        </div>
                    } */}

                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div className="notes-text-main-container">
                        <div className="notes-reminders-head">{res.Name}</div>
                        <div className="notes-reminders-text" style={{inlineSize:"150px"}}>{res.Note}</div>
                      </div>
                      {res.Status === "completed" ||
                      res.status === "Completed" ? (
                        <Tag color="cyan" className="completed-tag">
                          Completed
                        </Tag>
                      ) : (
                        <div className="note-btn-icon">
                          <Button
                            className="notes-reminders-btn"
                            onClick={() => {
                              dispatch(
                                updateNotes({
                                  noteId: res?._id,
                                  Status: "completed",
                                })
                              );
                            }}
                          >
                            Mark as Completed
                          </Button>
                          <Dropdown
                            overlay={menu}
                            trigger={["click"]}
                            onClick={() => {
                              setSelectedNote(res);
                            }}
                          >
                            <MoreOutlined />
                          </Dropdown>
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                      }}
                      className="notes-footer"
                    >
                      <div>
                        {moment().diff(res.EndTime) > res.EndTime ? (
                          <Tag icon={<ClockCircleOutlined />} color="error">
                            {moment(res.EndTime).format("MMMM DD, YYYY")}
                          </Tag>
                        ) : (
                          <Tag
                            icon={<ClockCircleOutlined />}
                            color="default"
                            className="reminders-tag"
                          >
                            {res.Status === "completed" ||
                            res.status === "Completed" ? (
                              <del>
                                {moment(res.EndTime).format("MMMM DD, YYYY")}
                              </del>
                            ) : (
                              moment(res.EndTime).format("MMMM DD, YYYY")
                            )}
                          </Tag>
                        )}
                      </div>
                      <div>
                        {
                          <Button
                            className="notes-reminders-btn2"
                            onClick={() => {
                              dispatch(
                                updateNotes({
                                  noteId: res?._id,
                                  Status: "completed",
                                })
                              );
                            }}
                          >
                            Mark as Completed
                          </Button>
                        }
                      </div>
                      <div
                        className="notes-created-date-main"
                        style={{
                          marginTop: "2%",
                          color: "#7a6d6d",
                          fontSize: "12px",
                        }}
                      >
                        {moment(res.Created).format("MMMM DD, YYYY")}
                      </div>
                    </div>
                  </>
                </div>
                {index >= 2 && (
                  <div
                    className="view-more-text"
                    onClick={() => {
                      setViewMore(true);
                    }}
                  >
                    View more
                  </div>
                )}
              </>
            );
          else {
            if (viewMore)
              return (
                <div className="notes-remonders-main">
                  {/* {notesData.length == 0 &&
                        <div className='no-notes-main'>
                            <div>
                                image here
                            </div>
                            <div className='no-notes-text'>No Notes to show</div>
                            <div className='no-notest-text2'>
                                Create note to display here to the other team members. You can set reminder to avoid missing any deadlines
                            </div>
                        </div>
                    } */}

                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div className="notes-text-main-container">
                        <div className="notes-reminders-head">{res.Name}</div>
                        <text className="notes-reminders-text">{res.Note}</text>
                      </div>
                      {res.Status === "completed" ||
                      res.status === "Completed" ? (
                        <Tag color="cyan" className="completed-tag">
                          Completed
                        </Tag>
                      ) : (
                        <div>
                          <Button
                            className="notes-reminders-btn"
                            onClick={() => {
                              dispatch(
                                updateNotes({
                                  noteId: res?._id,
                                  Status: "completed",
                                })
                              );
                            }}
                          >
                            Mark as Completed
                          </Button>
                          <Dropdown
                            overlay={menu}
                            trigger={["click"]}
                            onClick={() => {
                              setSelectedNote(res);
                            }}
                          >
                            <MoreOutlined />
                          </Dropdown>
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                      }}
                      className="notes-footer"
                    >
                      <div>
                        {moment().diff(res.EndTime) > 0 ? (
                          <>
                            <Tag
                              icon={<ClockCircleOutlined />}
                              color="error"
                              className="reminders-tag-error"
                            >
                              {moment(res.EndTime).format("MMMM DD, YYYY")}
                            </Tag>
                            <Tag className="overdue-tag">Overdue</Tag>
                          </>
                        ) : (
                          <Tag
                            icon={<ClockCircleOutlined />}
                            color="default"
                            className="reminders-tag"
                          >
                            {res.Status === "completed" ||
                            res.status === "Completed" ? (
                              <del>
                                {moment(res.EndTime).format("MMMM DD, YYYY")}
                              </del>
                            ) : (
                              moment(res.EndTime).format("MMMM DD, YYYY")
                            )}
                          </Tag>
                        )}
                      </div>
                      <div>
                        {
                          <Button
                            className="notes-reminders-btn2"
                            onClick={() => {
                              dispatch(
                                updateNotes({
                                  noteId: res?._id,
                                  Status: "completed",
                                })
                              );
                            }}
                          >
                            Mark as Completed
                          </Button>
                        }
                      </div>
                      <div
                        className="notes-created-date-main"
                        style={{
                          marginTop: "2%",
                          color: "#7a6d6d",
                          fontSize: "12px",
                        }}
                      >
                        {moment(res.Created).format("MMMM DD, YYYY")}
                      </div>
                    </div>
                  </>
                </div>
              );
          }
        })
      ) : (
        <div className="notes-remonders-main">
          {
            <div className="no-notes-main">
              <div>
                <img src={noData} />
              </div>
              <div className="no-notes-text">No Notes to show</div>
              <div className="no-notest-text2">
                Create note to display here to the other team members. You can
                set reminder to avoid missing any deadlines
              </div>
            </div>
          }
        </div>
      )}
    </div>
  );
};
export default AddNotes;
